import React from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { red } from '@material-ui/core/colors';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import store from '../../store/Store';
import './newproject.scss';
import Logo from '../logo/Logo';
import requestLogin from '../../actions/loginActions';
import StepperComponent from '../stepper/Stepper';

type newProjectState = {
	
}

type newProjectProps = {
	
}

class NewProject extends React.Component<newProjectProps, newProjectState> {

	handleChangeEmail = ((event) => {
		
	})

	handleChangePassword = ((event) => {
		
	})

	constructor(props) {
		super(props);

		this.handleChangeEmail = this.handleChangeEmail.bind(this);
		this.handleChangePassword = this.handleChangePassword.bind(this);
	}

	componentDidMount() {
		store.subscribe(() => {
			this.setState({
				
			})
		})
	}

  render() {
	  return (
	    <div className="NewProject">
	    	<StepperComponent />
	    </div>
	  );
  }
}

export default NewProject;